import { render, staticRenderFns } from "./TypingStatusIndicator.vue?vue&type=template&id=9cbe39f4&functional=true&"
import script from "./TypingStatusIndicator.vue?vue&type=script&lang=js&"
export * from "./TypingStatusIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../kiwiirc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports